import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { InboxOutlined } from '@ant-design/icons';
import { message, Upload } from 'antd';
import url from "../../../src/Development.json";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const { Dragger } = Upload;

const Dashboard = () => {

    const { Content } = Layout;
    const accessToken = localStorage.getItem("accessToken") || null
    let navigate = useNavigate();

    const props = {
        name: 'pdf_file',
        action: `${process.env.REACT_APP_BASE_URL + url.upload_pdf}`,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                message.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === 'error') {
                // message.error(`${info.file.name} file upload failed.`);
                message.error(`Pdf file with this name already exists.`);

            }
        },
    };

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await axios({ method: 'get', url: process.env.REACT_APP_BASE_URL + url.webhook_shopify_get, headers: { 'Authorization': 'Bearer ' + accessToken } })
                if (response && response.status === 200) {
          
                }
            } catch (error) {
                // message.error("Failed to fetch orders")
                if (error?.response?.status) {
                    debugger
                    if (error?.response?.status === 401) {
                        // redirect("/login")
                        message.error("Session expired")
                        // setLoading(false)
                        navigate("/login")

                    }
                }
                // navigate("/")
            }
        }
        fetchOrders()
    }, [])

    return (
        <Content className="site-layout-background">

            <div className="site-card-border-less-wrapper mt-2">
                <h1>Upload your PDF here </h1>
                <br />
                <Dragger
                    {...props}
                    maxCount={1}
                    className="pdf_upload_dragger"
                // onChange={fileUploadChange}
                >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                        banned files.
                    </p>
                </Dragger>
                <br />
                {/* <div className="upload_btn">
                    <Button type="primary" size={"large"} onClick={handleUpload}>
                        Upload
                    </Button>
                </div> */}
            </div>
        </Content>
    )
};

export default Dashboard;
